import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

export function Users() {
  return (
    <div>
      <div className="mb-4 flex items-center justify-between">
        <Input placeholder="Pesquisar usuários" className="mr-4 flex-1" />
        <div className="flex gap-2">
          <Button variant="outline">Novo Usuário</Button>
          <Button variant="outline">Nova Permissão</Button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white">
          <thead>
            <tr>
              <th className="border-b px-4 py-2 text-left">Nome</th>
              <th className="border-b px-4 py-2 text-left">Email</th>
              <th className="border-b px-4 py-2 text-left">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-t px-4 py-2">John Doe</td>
              <td className="border-t px-4 py-2">john@example.com</td>
              <td className="border-t px-4 py-2">
                <Button variant="outline" size="sm">
                  Editar
                </Button>
                <Button variant="outline" size="sm" className="ml-2">
                  Permissões
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
